module.exports = __webpack_public_path__ + "static/img/康刻尔2.bcc51d63.png";